import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import bescServices from "../../Assets/services.png";
import buildersEdge from "../../Assets/builders.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Our <strong className="purple">Platforms </strong>
        </h1>
        <p style={{ color: "white" }}>
          Explore our official websites and exchange platform
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={6} className="project-card">
            <ProjectCard
              imgPath={bescServices}
              isBlog={false}
              title="BESC Services"
              description="Official company website for Builders Edge Services & Construction (BESC LLC). Explore our construction and renovation services, view our portfolio, and learn about our professional team."
              ghLink=""
              demoLink="https://besc.services"
            />
          </Col>

          <Col md={6} className="project-card">
            <ProjectCard
              imgPath={buildersEdge}
              isBlog={false}
              title="Builders Edge Exchange"
              description="Our own centralized exchange platform (Builders Exchange) where you can trade BESC tokens and other cryptocurrencies. Features secure trading, real-time market data, and integrated wallet services."
              ghLink=""
              demoLink="https://bescexchange.xyz"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
